import React, { useEffect, useState } from 'react'
import constant from '../../../constant'
import { Link, useLocation, withRouter } from 'react-router-dom/cjs/react-router-dom.min'
import { v2_categories, v2_plan_type } from '../../../actions/v2/masterData';
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import { v2_all_user } from '../../../actions/v2/user';

const Filter = ({ onChangeFilter, planCountByStatus }) => {
    const location = useLocation();
    const { projectId, projectName } = location.state;

    const [state, setState] = useState({
        type: { name: 'type', value: '', options: [] },
        category: { name: 'category', value: '', options: [] },
        keyword: { name: 'keyword', value: '' },
        favourite: { name: 'favourite', value: false },
        hasMyComment: { name: 'hasMyComment', value: false },
        assignedUser: { name: 'assignedUser', value: '', options: [] },
        status: { name: 'status', value: '', options: ['Draft', 'Approved', 'Approved With Comments', 'Not Accepted', 'Reference'] },
        startDate: { name: 'startDate', value: '' },
        endDate: { name: 'endDate', value: '' }

    });


    const handleChange = (e) => {
        const { name, value } = e.target;
        setState(prev => ({
            ...prev,
            [name]: {
                ...prev[name],
                value: value
            }
        }));
    };

    useEffect(() => {
        const model = {
            typeId: state.type.value,
            categoryId: state.category.value,
            favourite: state.favourite.value,
            hasMyComment: state.hasMyComment.value,
            assignedUser: state.assignedUser.value,
            keyword: state.keyword.value,
            status: state.status.value,
            startDate: state.startDate.value,
            endDate: state.endDate.value,
        }
        onChangeFilter(model)
    }, [state])
    useEffect(() => {
        v2_plan_type().then((res) => {
            if (res.status && res.result) {
                setState((prev) => ({
                    ...prev,
                    type: {
                        ...prev.type,
                        options: res.result.map((item) => ({
                            label: item.PLAN_TYPE,
                            value: item.ID,
                        }))
                    }
                }));
            }
        });

        v2_categories().then((res) => {
            if (res.status && res.result) {
                setState((prev) => ({
                    ...prev,
                    category: {
                        ...prev.category,
                        options: res.result.map((item) => ({
                            label: item.CATEGORY_NAME,
                            value: item.ID,
                        }))
                    }
                }));
            }
        })

        v2_all_user().then((res) => {
            if (res.status && res.result) {
                setState((prev) => ({
                    ...prev,
                    assignedUser: {
                        ...prev.assignedUser,
                        options: res.result.map((item) => ({
                            label: item.FULL_NAME,
                            value: item.USER_ID,
                        }))
                    }
                }));
            }
        })
    }, []);


    return (
        <div className="row">

            <div className=" d-flex justify-content-between align-items-center mb-2">
                <h4 className="card-title mb-0"></h4>
                <div>
                    <button
                        type="button"
                        data-bs-toggle="modal"
                        data-bs-target="#plan-approval-export-columns-modal"
                        className="btn btn-sm btn-primary me-2"
                        style={{
                            backgroundImage:
                                "linear-gradient(90deg, rgb(104, 149, 180), rgb(38, 85, 120))"
                        }}
                    >
                        <i className="mdi mdi-file-excel-outline label-icon" /> Export
                    </button>
                    <Link
                        to={{
                            pathname: constant.Authedcomponent.planApprovalCreate.url,
                            state: {
                                projectId,
                                projectName
                            }
                        }}
                        className="btn btn-sm btn-primary me-2"
                        style={{
                            backgroundImage:
                                "linear-gradient(90deg, rgb(104, 149, 180), rgb(38, 85, 120))"
                        }}
                    >
                        <i className="fa fa-plus-circle label-icon" /> Create Plan
                    </Link>

                </div>
            </div>
            <div className="col-md-12 ">
                <div className="plan-approval-index-top">
                    <div className="filter-channels-box">
                        <div className="type-filter">
                            <div className="channels-type">
                                <select className="form-select"
                                    onChange={handleChange}
                                    value={state.type.value}
                                    name={state.type.name}
                                >
                                    <option value={''}>All Type</option>
                                    {state.type.options.map((option) => {
                                        return (
                                            <option value={option.value}>{option.label}</option>
                                        )
                                    })}
                                </select>
                            </div>
                            <div className="channels-type">
                                <select className="form-select"
                                    onChange={handleChange}
                                    value={state.category.value}
                                    name={state.category.name}
                                >
                                    <option value={''}>All Categories</option>
                                    {state.category.options.map((option) => {
                                        return (
                                            <option value={option.value}>{option.label}</option>
                                        )
                                    })}
                                </select>
                            </div>
                        </div>
                        <div className="stats-channels-type">
                            <div className="counter-box">
                                <div className="name">Draft</div>
                                <div className="value">{planCountByStatus?.Draft}</div>
                            </div>
                            <div className="counter-box">
                                <div className="name">Approved</div>
                                <div className="value">{planCountByStatus?.Approved}</div>
                            </div>
                            <div className="counter-box">
                                <div className="name">Approved With Comments</div>
                                <div className="value">{planCountByStatus?.['Approved With Comments']}</div>
                            </div>
                            <div className="counter-box">
                                <div className="name">Not Accepted</div>
                                <div className="value">{planCountByStatus?.['Not Accepted']}</div>
                            </div>
                            <div className="counter-box">
                                <div className="name">Reference</div>
                                <div className="value">{planCountByStatus?.Reference}</div>
                            </div>
                        </div>
                    </div>
                    <div className="filter-tab-channels-box">
                        <div className="input-box" style={{ width: 177 }}>
                            <input
                                type="text"
                                className="form-control"
                                placeholder="Search DFA No./ Plan Name"
                                value={state.keyword.value}
                                name={state.keyword.name}
                                onChange={handleChange}
                            />
                        </div>
                        <div
                            className={state.hasMyComment.value ? 'input-box active' : 'input-box'}

                        >
                            <button
                                type="button"
                                onClick={() =>
                                    handleChange({
                                        target: {
                                            name: 'hasMyComment',
                                            value: !state.hasMyComment.value,
                                        },
                                    })
                                }
                            >
                                Has My Comments
                            </button>
                        </div>
                        <div
                            className={state.favourite.value ? 'input-box active' : 'input-box'}
                        >
                            <button type="button"
                                onClick={() =>
                                    handleChange({
                                        target: {
                                            name: 'favourite',
                                            value: !state.favourite.value,
                                        },
                                    })
                                }

                            >
                                <i className="bx bx-star" /> Favourites
                            </button>
                        </div>
                        {/* <div className="input-box">
                            <button type="button">
                                <i className="fa fa-reply" /> Reply Owed
                            </button>
                        </div> */}
                        {/* <div className="input-box">
                            <button type="button">
                                <i className="fa fa-reply-all" /> Reply Owed - Urgent
                            </button>
                        </div> */}
                        {/* <div className="input-box">
                            <button type="button">
                                <i className="fa fa-reply-all" /> Reply Owed Third Party-
                                Urgent
                            </button>
                        </div> */}
                        <div className="input-box">
                            <button type="button">
                                <i className="fa fa-edit" /> Has Draft Reply
                            </button>
                        </div>
                        <div className="input-box">
                            <button type="button">
                                <i className="fa fa-bolt" /> Has Follow Up
                            </button>
                        </div>
                        {/* <div className="input-box">
                            <select className="form-select">
                                <option>Revision Status</option>
                                <option>CL-001</option>
                                <option>CL-002</option>
                                <option>CL-003</option>
                                <option>CL-004</option>
                            </select>
                        </div>
                        <div className="input-box">
                            <select className="form-select">
                                <option>Review Status</option>
                                <option>CL-001</option>
                                <option>CL-002</option>
                                <option>CL-003</option>
                                <option>CL-004</option>
                            </select>
                        </div> */}
                        <div className="input-box">
                            <select className="form-select"
                                onChange={handleChange}
                                value={state.assignedUser.value}
                                name={state.assignedUser.name}
                            >
                                <option value={''}>All Assigned User</option>
                                {state.assignedUser.options.map((option) => {
                                    return (
                                        <option value={option.value}>{option.label}</option>
                                    )
                                })}
                            </select>
                        </div>
                        <div className="input-box">
                            <select className="form-select"
                                onChange={handleChange}
                                value={state.status.value}
                                name={state.status.name}
                            >
                                <option value={''}>Select Status</option>
                                {state.status.options.map((option) => {
                                    return (
                                        <option value={option}>{option}</option>
                                    )
                                })}
                            </select>
                        </div>


                        <div className="input-box">

                            <input
                                className={`form-control `}
                                type="text"
                                onFocus={(e) => (e.target.type = "date")}
                                onBlur={(e) => !e.target.value && (e.target.type = "text")}
                                placeholder="Select Start Date"
                                onChange={handleChange}
                                value={state.startDate?.value || ""}
                                name={state.startDate?.name}
                            />

                        </div>

                        <div className="input-box">
                            <input
                                className={`form-control `}
                                type="text"
                                onFocus={(e) => (e.target.type = "date")}
                                onBlur={(e) => !e.target.value && (e.target.type = "text")}
                                placeholder="Select End Date"
                                onChange={handleChange}
                                value={state.endDate?.value || ""}
                                name={state.endDate?.name}
                            />
                        </div>



                    </div>
                </div>
            </div>
        </div >
    )
}

export default withRouter(Filter)
